export default [{
  path: 'specialEquipmentManage',
  name: 'specialEquipmentManage',
  component: function component() {
    return import('@/views/specialEquipmentManage/index');
  }
}, {
  path: 'operatorAdd',
  name: 'operatorAdd',
  component: function component() {
    return import('@/views/specialEquipmentManage/operator/operatorAdd');
  }
}, {
  path: 'operatorMaintenanceAdd',
  name: 'operatorMaintenanceAdd',
  component: function component() {
    return import('@/views/specialEquipmentManage/operator/operatorMaintenanceAdd');
  }
}, {
  path: 'operatorMaintenanceDetail',
  name: 'operatorMaintenanceDetail',
  component: function component() {
    return import('@/views/specialEquipmentManage/operator/operatorMaintenanceDetail');
  }
}, {
  path: 'operatorSuccess',
  name: 'operatorSuccess',
  component: function component() {
    return import('@/views/specialEquipmentManage/operator/components/operatorSuccess');
  }
}, {
  path: 'operatorMaintenanceSuccess',
  name: 'operatorMaintenanceSuccess',
  component: function component() {
    return import('@/views/specialEquipmentManage/operator/components/operatorMaintenanceSuccess');
  }
}, {
  path: 'responsiblePersonSuccess',
  name: 'responsiblePersonSuccess',
  component: function component() {
    return import('@/views/specialEquipmentManage/operator/components/responsiblePersonSuccess');
  }
}, {
  path: 'responsiblePersonMaintenanceSuccess',
  name: 'responsiblePersonMaintenanceSuccess',
  component: function component() {
    return import('@/views/specialEquipmentManage/operator/components/responsiblePersonMaintenanceSuccess');
  }
}, {
  path: 'operatorDetail',
  name: 'operatorDetail',
  component: function component() {
    return import('@/views/specialEquipmentManage/operator/operatorDetail');
  }
}, {
  path: 'operatorsList',
  name: 'operatorsList',
  component: function component() {
    return import('@/views/specialEquipmentManage/operator/operatorList');
  }
}, {
  path: 'operatorAccountClosure',
  name: 'operatorAccountClosure',
  component: function component() {
    return import('@/views/specialEquipmentManage/operator/operatorAccountClosure');
  }
}, {
  path: 'responsiblePersonAdd',
  name: 'responsiblePersonAdd',
  component: function component() {
    return import('@/views/specialEquipmentManage/operator/responsiblePersonAdd');
  }
}, {
  path: 'responsiblePersonDetail',
  name: 'responsiblePersonDetail',
  component: function component() {
    return import('@/views/specialEquipmentManage/operator/responsiblePersonDetail');
  }
}, {
  path: 'responsiblePersonMaintenanceAdd',
  name: 'responsiblePersonMaintenanceAdd',
  component: function component() {
    return import('@/views/specialEquipmentManage/operator/responsiblePersonMaintenanceAdd');
  }
}, {
  path: 'responsiblePersonMaintenanceDetail',
  name: 'responsiblePersonMaintenanceDetail',
  component: function component() {
    return import('@/views/specialEquipmentManage/operator/responsiblePersonMaintenanceDetail');
  }
}, {
  path: 'responsiblePersonList',
  name: 'responsiblePersonList',
  component: function component() {
    return import('@/views/specialEquipmentManage/operator/responsiblePersonList');
  }
}, {
  path: 'securityStaffConfigStatistics',
  name: 'securityStaffConfigStatistics',
  component: function component() {
    return import('@/views/specialEquipmentManage/operator/securityStaffConfigStatistics');
  }
}, {
  path: 'responsiblePersonAccountClosure',
  name: 'responsiblePersonAccountClosure',
  component: function component() {
    return import('@/views/specialEquipmentManage/operator/responsiblePersonAccountClosure');
  }
}, {
  path: 'operatorLicenseExpirationList',
  name: 'operatorLicenseExpirationList',
  component: function component() {
    return import('@/views/specialEquipmentManage/operator/operatorLicenseExpirationList');
  }
}, {
  path: 'specialVehicleAdd',
  name: 'specialVehicleAdd',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialEquipment/add');
  }
}, {
  path: 'specialVehicleDetail',
  name: 'specialVehicleDetail',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialEquipment/detail');
  }
}, {
  path: 'specialVehicleMaintenanceAdd',
  name: 'specialVehicleMaintenanceAdd',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialEquipment/maintenanceAdd');
  }
}, {
  path: 'specialVehicleMaintenanceDetail',
  name: 'specialVehicleMaintenanceDetail',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialEquipment/maintenanceDetail');
  }
}, {
  path: 'specialVehicleMaintenanceSuccess',
  name: 'specialVehicleMaintenanceSuccess',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialEquipment/maintenanceSuccess');
  }
}, {
  path: 'specialVehicleSuccess',
  name: 'specialVehicleSuccess',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialEquipment/success');
  }
}, {
  path: 'specialEquipmentList',
  name: 'specialEquipmentList',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialEquipment/list');
  }
}, {
  path: 'normalEquipmentList',
  name: 'normalEquipmentList',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialEquipment/normalEquipment/list');
  }
}, {
  path: 'equipmentLicenseExpiresList',
  name: 'equipmentLicenseExpiresList',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialEquipment/expiresList');
  }
}, {
  path: 'specialVehicleSelfEnterRecordAdd',
  name: 'specialVehicleSelfEnterRecordAdd',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleSelfEnterRecord/add');
  }
}, {
  path: 'specialVehicleSelfEnterRecordAddList',
  name: 'specialVehicleSelfEnterRecordAddList',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleSelfEnterRecord/addList');
  }
}, {
  path: 'specialVehicleSelfEnterRecordDetail',
  name: 'specialVehicleSelfEnterRecordDetail',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleSelfEnterRecord/detail');
  }
}, {
  path: 'specialVehicleSelfEnterRecordList',
  name: 'specialVehicleSelfEnterRecordList',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleSelfEnterRecord/list');
  }
}, {
  path: 'specialVehicleSelfEnterRecordSuccess',
  name: 'specialVehicleSelfEnterRecordSuccess',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleSelfEnterRecord/success');
  }
}, {
  path: 'specialVehicleSelfOuterRecordAdd',
  name: 'specialVehicleSelfOuterRecordAdd',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleSelfOuterRecord/add');
  }
}, {
  path: 'specialVehicleSelfOuterRecordAddList',
  name: 'specialVehicleSelfOuterRecordAddList',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleSelfOuterRecord/addList');
  }
}, {
  path: 'specialVehicleSelfOuterRecordDetail',
  name: 'specialVehicleSelfOuterRecordDetail',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleSelfOuterRecord/detail');
  }
}, {
  path: 'specialVehicleSelfOuterRecordList',
  name: 'specialVehicleSelfOuterRecordList',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleSelfOuterRecord/list');
  }
}, {
  path: 'specialVehicleSelfOuterRecordSuccess',
  name: 'specialVehicleSelfOuterRecordSuccess',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleSelfOuterRecord/success');
  }
}, {
  // 设备交接鉴定表管理 2022-07-12 重做
  path: 'specialVehicleHandOverManage',
  name: 'specialVehicleHandOverManage',
  component: function component() {
    return import('@/components/vehicleManagement/vehicleHandOverManage/index.vue');
  }
}, {
  // 设备交接鉴定表管理 2022-07-12 重做
  path: 'specialVehicleHandOverExitManage',
  name: 'specialVehicleHandOverExitManage',
  component: function component() {
    return import('@/components/vehicleManagement/vehicleHandOverManage/index.vue');
  }
}, {
  path: 'specialVehicleThirdEnterList',
  name: 'specialVehicleThirdEnterList',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleThird/enter/index.vue');
  }
}, {
  path: 'specialVehicleThirdEnterDetail',
  name: 'specialVehicleThirdEnterDetail',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleThird/enter/detail.vue');
  }
}, {
  path: 'specialVehicleThirdOuterList',
  name: 'specialVehicleThirdOuterList',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleThird/outer/index.vue');
  }
}, {
  path: 'specialVehicleThirdOuterDetail',
  name: 'specialVehicleThirdOuterDetail',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleThird/outer/detail.vue');
  }
}, {
  path: 'specialVehicleThirdSuccess',
  name: 'specialVehicleThirdSuccess',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleThird/success.vue');
  }
}, {
  path: 'specialVehicleSecurityCheckDetail',
  name: 'specialVehicleSecurityCheckDetail',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleSecurityCheck/detail.vue');
  }
}, {
  path: 'specialVehicleSecurityCheckSuccess',
  name: 'specialVehicleSecurityCheckSuccess',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleSecurityCheck/success.vue');
  }
}, {
  path: 'specialVehicleSecurityCheckDay',
  name: 'specialVehicleSecurityCheckDay',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleSecurityCheck/day.vue');
  }
}, {
  path: 'specialVehicleSecurityCheckWeek',
  name: 'specialVehicleSecurityCheckWeek',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleSecurityCheck/week.vue');
  }
}, {
  path: 'specialVehicleSecurityCheckMonth',
  name: 'specialVehicleSecurityCheckMonth',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleSecurityCheck/month.vue');
  }
}, {
  path: 'specialVehicleSecurityCheckSpecialCheck',
  name: 'specialVehicleSecurityCheckSpecialCheck',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleSecurityCheck/specialCheck.vue');
  }
}, {
  path: 'specialVehicleMonitorInfo',
  name: 'specialVehicleMonitorInfo',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleMonitor/info/index.vue');
  }
}, {
  path: 'specialVehicleMonitorSummary',
  name: 'specialVehicleMonitorSummary',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleMonitor/summary/index.vue');
  }
}, {
  path: 'specialVehicleMonitorAlarmEquipmenList',
  name: 'specialVehicleMonitorAlarmEquipmenList',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleMonitor/alarmEquipmen/index.vue');
  }
}, {
  path: 'specialVehicleMonitorTerminalList',
  name: 'specialVehicleMonitorTerminalList',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleMonitor/terminalList/index.vue');
  }
}, {
  path: 'questionBankList',
  name: 'questionBankList',
  component: function component() {
    return import('@/views/specialEquipmentManage/examination/question/list');
  }
}, {
  path: 'questionBankImport',
  name: 'questionBankImport',
  component: function component() {
    return import('@/views/specialEquipmentManage/examination/question/import');
  }
}, {
  path: 'questionBankDetail',
  name: 'questionBankDetail',
  component: function component() {
    return import('@/views/specialEquipmentManage/examination/question/detail');
  }
}, {
  path: 'dayTrainingTable',
  name: 'dayTrainingTable',
  component: function component() {
    return import('@/views/specialEquipmentManage/examination/dayList');
  }
}, {
  path: 'personExamTable',
  name: 'personExamTable',
  component: function component() {
    return import('@/views/specialEquipmentManage/examination/personExamList');
  }
}, {
  path: 'personExamDetail',
  name: 'personExamDetail',
  component: function component() {
    return import('@/views/specialEquipmentManage/examination/personExamDetail');
  }
}, {
  path: 'technicalInformationAddList',
  name: 'technicalInformationAddList',
  component: function component() {
    return import('@/views/specialEquipmentManage/technicalInformation/technicalArchives/addList');
  }
}, {
  path: 'technicalInformationRecordList',
  name: 'technicalInformationRecordList',
  component: function component() {
    return import('@/views/specialEquipmentManage/technicalInformation/technicalArchives/recordList');
  }
}, {
  path: 'regularInspectionAddList',
  name: 'regularInspectionAddList',
  component: function component() {
    return import('@/views/specialEquipmentManage/technicalInformation/regularInspection/addList');
  }
}, {
  path: 'regularInspectionRecordList',
  name: 'regularInspectionRecordList',
  component: function component() {
    return import('@/views/specialEquipmentManage/technicalInformation/regularInspection/recordList');
  }
}, {
  path: 'dailyUseAddList',
  name: 'dailyUseAddList',
  component: function component() {
    return import('@/views/specialEquipmentManage/technicalInformation/dailyUse/addList');
  }
}, {
  path: 'dailyUseRecordList',
  name: 'dailyUseRecordList',
  component: function component() {
    return import('@/views/specialEquipmentManage/technicalInformation/dailyUse/recordList');
  }
}, {
  path: 'maintenanceAddList',
  name: 'maintenanceAddList',
  component: function component() {
    return import('@/views/specialEquipmentManage/technicalInformation/maintenance/addList');
  }
}, {
  path: 'maintenanceRecordList',
  name: 'maintenanceRecordList',
  component: function component() {
    return import('@/views/specialEquipmentManage/technicalInformation/maintenance/recordList');
  }
}, {
  path: 'faultAccidentAddList',
  name: 'faultAccidentAddList',
  component: function component() {
    return import('@/views/specialEquipmentManage/technicalInformation/faultAccident/addList');
  }
}, {
  path: 'faultAccidentRecordList',
  name: 'faultAccidentRecordList',
  component: function component() {
    return import('@/views/specialEquipmentManage/technicalInformation/faultAccident/recordList');
  }
}, {
  path: 'energyTransformationAddList',
  name: 'energyTransformationAddList',
  component: function component() {
    return import('@/views/specialEquipmentManage/technicalInformation/energyTransformation/addList');
  }
}, {
  path: 'energyTransformationRecordList',
  name: 'energyTransformationRecordList',
  component: function component() {
    return import('@/views/specialEquipmentManage/technicalInformation/energyTransformation/recordList');
  }
}, {
  path: 'technicalInformationDetail',
  name: 'technicalInformationDetail',
  component: function component() {
    return import('@/views/specialEquipmentManage/technicalInformation/detail');
  }
}, {
  path: 'technicalInformationSuccess',
  name: 'technicalInformationSuccess',
  component: function component() {
    return import('@/views/specialEquipmentManage/technicalInformation/components/technicalInformationSuccess');
  }
}, {
  path: 'securityCheckInvestigateDayAdd',
  name: 'securityCheckInvestigateDayAdd',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleSecurityCheck/investigate/day/add');
  }
}, {
  path: 'securityCheckInvestigateDayList',
  name: 'securityCheckInvestigateDayList',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleSecurityCheck/investigate/day/list');
  }
}, {
  path: 'securityCheckInvestigateDayDetail',
  name: 'securityCheckInvestigateDayDetail',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleSecurityCheck/investigate/day/detail');
  }
}, {
  path: 'securityCheckInvestigateWeekAdd',
  name: 'securityCheckInvestigateWeekAdd',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleSecurityCheck/investigate/week/add');
  }
}, {
  path: 'securityCheckInvestigateWeekList',
  name: 'securityCheckInvestigateWeekList',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleSecurityCheck/investigate/week/list');
  }
}, {
  path: 'securityCheckInvestigateWeekDetail',
  name: 'securityCheckInvestigateWeekDetail',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleSecurityCheck/investigate/week/detail');
  }
}, {
  path: 'securityCheckInvestigateMonthAdd',
  name: 'securityCheckInvestigateMonthAdd',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleSecurityCheck/investigate/month/add');
  }
}, {
  path: 'securityCheckInvestigateMonthList',
  name: 'securityCheckInvestigateMonthList',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleSecurityCheck/investigate/month/list');
  }
}, {
  path: 'securityCheckInvestigateMonthDetail',
  name: 'securityCheckInvestigateMonthDetail',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleSecurityCheck/investigate/month/detail');
  }
}, {
  path: 'securityCheckInvestigateSpecialCheckAdd',
  name: 'securityCheckInvestigateSpecialCheckAdd',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleSecurityCheck/investigate/specialCheck/add');
  }
}, {
  path: 'securityCheckInvestigateSpecialCheckList',
  name: 'securityCheckInvestigateSpecialCheckList',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleSecurityCheck/investigate/specialCheck/list');
  }
}, {
  path: 'securityCheckInvestigateSpecialCheckDetail',
  name: 'securityCheckInvestigateSpecialCheckDetail',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleSecurityCheck/investigate/specialCheck/detail');
  }
}, {
  path: 'issueRectifyList',
  name: 'issueRectifyList',
  component: function component() {
    return import('@/views/specialEquipmentManage/issueRectify/list');
  }
}, {
  path: 'issueRectifySuccess',
  name: 'issueRectifySuccess',
  component: function component() {
    return import('@/views/specialEquipmentManage/issueRectify/success');
  }
}, {
  path: 'specialVehicleWeeklyCheckEdit',
  name: 'specialVehicleWeeklyCheckEdit',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleWeeklyCheck/edit');
  }
}, {
  path: 'specialVehicleWeeklyCheckList',
  name: 'specialVehicleWeeklyCheckList',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleWeeklyCheck/list');
  }
}, {
  path: 'specialVehicleWeeklyCheckDetail',
  name: 'specialVehicleWeeklyCheckDetail',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleWeeklyCheck/detail');
  }
}, {
  path: 'specialVehicleWeeklyCheckSuccess',
  name: 'specialVehicleWeeklyCheckSuccess',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleWeeklyCheck/success');
  }
}, {
  path: 'specialVehicleMonthlyMeetingEdit',
  name: 'specialVehicleMonthlyMeetingEdit',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleMonthlyMeeting/edit');
  }
}, {
  path: 'specialVehicleMonthlyMeetingList',
  name: 'specialVehicleMonthlyMeetingList',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleMonthlyMeeting/list');
  }
}, {
  path: 'specialVehicleMonthlyMeetingDetail',
  name: 'specialVehicleMonthlyMeetingDetail',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleMonthlyMeeting/detail');
  }
}, {
  path: 'specialVehicleMonthlyMeetingSuccess',
  name: 'specialVehicleMonthlyMeetingSuccess',
  component: function component() {
    return import('@/views/specialEquipmentManage/specialVehicleMonthlyMeeting/success');
  }
}, {
  path: 'specialVehicleEmergencyAdd',
  name: 'specialVehicleEmergencyAdd',
  component: function component() {
    return import('@/views/specialEquipmentManage/emergency/add');
  }
}, {
  path: 'specialVehicleEmergencyList',
  name: 'specialVehicleEmergencyList',
  component: function component() {
    return import('@/views/specialEquipmentManage/emergency/list');
  }
}, {
  path: 'specialVehicleEmergencySuccess',
  name: 'specialVehicleEmergencySuccess',
  component: function component() {
    return import('@/views/specialEquipmentManage/emergency/success');
  }
}];